module.exports = __webpack_public_path__ + "static/media/asset_1.07d902b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/asset_1.jpg
// module id = 309
// module chunks = 0